import styled from "styled-components";
import { Button } from '@gr-monorepo/common/ui';

export const ModalWrap = styled.div`
  width: 832px;
  padding: 24px 32px 32px 32px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 12px 24px rgba(57, 78, 127, 0.2);
  border-radius: 16px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const Text = styled.p`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
`;

export const ButtonStyle = styled(Button)`
  padding: 11px 24px;
  width: 200px;
  height: 46px;
  border-radius: 8px;
  &:hover {
  background-color: transparent;
    opacity: 0.8;
  }
  border: 2px solid #985EFF;
  background-color: transparent;
`;
